import { render } from "./LocaleShippingText.vue?vue&type=template&id=2857f79a"
import script from "./LocaleShippingText.vue?vue&type=script&lang=js"
export * from "./LocaleShippingText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__